"use client";

import { motion, useInView } from "motion/react";
import React from "react";
import { cn } from "@/lib/utils";
import type { TextHighlightProps } from "../types";

function TextHighlight({
  ref,
  text,
  className,
  inView = false,
  inViewMargin = "0px",
  transition = { duration: 2, ease: "easeInOut" },
  ...props
}: TextHighlightProps) {
  const localRef = React.useRef<HTMLSpanElement>(null);

  React.useImperativeHandle(ref, () => localRef.current as HTMLSpanElement);

  const inViewResult = useInView(localRef, {
    once: true,
    margin: inViewMargin,
  });

  const isInView = !inView || inViewResult;

  return (
    <motion.span
      ref={localRef}
      data-slot="highlight-text"
      initial={{
        backgroundSize: "0% 100%",
      }}
      animate={isInView ? { backgroundSize: "100% 100%" } : undefined}
      transition={transition}
      style={{
        backgroundRepeat: "no-repeat",
        backgroundPosition: "left center",
        display: "inline",
      }}
      className={cn(
        `relative inline-block px-2 rounded-sm bg-gradient-to-r from-primary to-primary`,
        className,
      )}
      {...props}
    >
      {text}
    </motion.span>
  );
}

export default TextHighlight;
